module.exports = __webpack_public_path__ + "img/行业应用_生物制药.45dbd1e9.svg";